/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardAccessViolationByTrend {
    getFixupPrototypeFunction() { return SecurityDashboardAccessViolationByTrend.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardAccessViolationByTrend>): SecurityDashboardAccessViolationByTrend {
        let obj = Object.assign(new SecurityDashboardAccessViolationByTrend(), model);
        SecurityDashboardAccessViolationByTrend.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardAccessViolationByTrend>): SecurityDashboardAccessViolationByTrend {
        if (!model) return null;
        return SecurityDashboardAccessViolationByTrend.newInstance(<SecurityDashboardAccessViolationByTrend> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardAccessViolationByTrend) {
        if (!obj) return;

        models.SecurityDashboardAccessViolationByTrend.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardAccessViolationByTrend): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardAccessViolationByTrend.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.month === "string") {
            this.month = new Date(<string><any>this.month);
        }
        if (this.count_by_severity) {
            models.SecurityDashboardSeverity.fixupPrototype(this.count_by_severity);
        }
    }

    /**
     * Access Violation Month
     */
    month: Date;

    /**
     * Access Violations Severity Values
     */
    count_by_severity: models.SecurityDashboardSeverity;

}
